import ApproverSignoffPage from './ApproverSignoffPage'

export default function HeadSignoff () {
  return <ApproverSignoffPage level={2} />
}
